import type { ReactNode } from "react";
import { WalkthroughProvider as SharedProvider } from "@shared/lib/walkthrough";
import type { WalkthroughConfig } from "@shared/lib/walkthrough";
import { introCards } from "./introCardsData";
import { tourSteps } from "./tourSteps";

export { useWalkthrough } from "@shared/lib/walkthrough";

const config: WalkthroughConfig = {
  storageKey: "cradleos:employee:walkthrough-done",
  introCards,
  tourSteps,
  completionField: "mobile_tour_completed_at",
};

export function WalkthroughProvider({ children }: { children: ReactNode }) {
  return <SharedProvider config={config}>{children}</SharedProvider>;
}
